import React from "react";
import { Download } from "lucide-react";

export const CsvButton = ({ onClick, label = "CSV", testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="flex min-h-[36px] items-center gap-1.5 rounded-lg border border-slate-700 bg-slate-900/70 px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-wider text-slate-300 transition-colors hover:border-cyan-600 hover:text-cyan-300"
  >
    <Download className="h-3.5 w-3.5" /> {label}
  </button>
);

export default CsvButton;
